var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProLight1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.498,
    height: 58.5,
    viewBox: "0 0 58.498 58.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35455",
    "data-name": "Gruppe 35455",
    transform: "translate(-326.69 -1754.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-list",
    transform: "translate(326.941 1754.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46794",
    "data-name": "Pfad 46794",
    d: "M193.133,452a1.133,1.133,0,1,0,.8.332A1.142,1.142,0,0,0,193.133,452Zm0,0",
    transform: "translate(-170.25 -400.798)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46795",
    "data-name": "Pfad 46795",
    d: "M56.79,15.442a4.133,4.133,0,0,0-5.839,0l-5.186,5.186V3.851A3.856,3.856,0,0,0,41.914,0H3.851A3.856,3.856,0,0,0,0,3.851v50.3A3.856,3.856,0,0,0,3.851,58H41.914a3.856,3.856,0,0,0,3.852-3.852V32.306L56.79,21.281a4.133,4.133,0,0,0,0-5.839ZM43.5,3.851V22.894l-2.266,2.266V5.663A1.133,1.133,0,0,0,40.1,4.531H32.53V2.265h9.383A1.588,1.588,0,0,1,43.5,3.851ZM37.314,34.918l1.529-3.436,1.906,1.906ZM30.265,2.265V6.881A1.276,1.276,0,0,1,28.99,8.156H16.775A1.276,1.276,0,0,1,15.5,6.881V2.265ZM41.914,55.734H3.851a1.588,1.588,0,0,1-1.586-1.586V3.851A1.588,1.588,0,0,1,3.851,2.265h9.383V4.531H5.664A1.133,1.133,0,0,0,4.531,5.663V52.335a1.133,1.133,0,0,0,1.133,1.133H18.351a1.133,1.133,0,0,0,0-2.266H6.8V6.8h6.438v.085a3.544,3.544,0,0,0,3.54,3.54H28.99a3.544,3.544,0,0,0,3.54-3.54V6.8h6.438V27.425l-1.29,1.29a1.146,1.146,0,0,0-.234.34l-3.4,7.637a1.133,1.133,0,0,0,1.5,1.5l3.429-1.527V51.2H27.414a1.133,1.133,0,0,0,0,2.266H40.1a1.133,1.133,0,0,0,1.133-1.133V35.653l1.943-.865a1.129,1.129,0,0,0,.323-.218V54.148a1.588,1.588,0,0,1-1.586,1.586ZM50.966,23.9l-8.25,8.25-2.635-2.635L50.3,19.3l2.635,2.635Zm4.222-4.222-.656.655L51.9,17.7l.655-.655a1.863,1.863,0,1,1,2.635,2.635Zm0,0",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46796",
    "data-name": "Pfad 46796",
    d: "M96.383,120h-7.25A1.133,1.133,0,0,0,88,121.133v7.25a1.133,1.133,0,0,0,1.133,1.133h7.25a1.133,1.133,0,0,0,1.133-1.133v-7.25A1.133,1.133,0,0,0,96.383,120Zm-1.133,7.25H90.266v-4.984H95.25Zm0,0",
    transform: "translate(-78.032 -106.407)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46797",
    "data-name": "Pfad 46797",
    d: "M96.383,230h-7.25A1.133,1.133,0,0,0,88,231.133v7.25a1.133,1.133,0,0,0,1.133,1.133h7.25a1.133,1.133,0,0,0,1.133-1.133v-7.25A1.133,1.133,0,0,0,96.383,230Zm-1.133,7.25H90.266v-4.984H95.25Zm0,0",
    transform: "translate(-78.032 -203.946)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46798",
    "data-name": "Pfad 46798",
    d: "M96.383,340h-7.25A1.133,1.133,0,0,0,88,341.133v7.25a1.133,1.133,0,0,0,1.133,1.133h7.25a1.133,1.133,0,0,0,1.133-1.133v-7.25A1.133,1.133,0,0,0,96.383,340Zm-1.133,7.25H90.266v-4.984H95.25Zm0,0",
    transform: "translate(-78.032 -301.485)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46799",
    "data-name": "Pfad 46799",
    d: "M211.253,136.475a1.132,1.132,0,0,0,1.6,0l5.114-5.114a1.133,1.133,0,0,0-1.6-1.6l-4.313,4.313-1.719-1.719a1.133,1.133,0,0,0-1.6,1.6Zm0,0",
    transform: "translate(-184.794 -114.765)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46800",
    "data-name": "Pfad 46800",
    d: "M211.253,246.477a1.132,1.132,0,0,0,1.6,0l5.114-5.114a1.133,1.133,0,0,0-1.6-1.6l-4.313,4.314-1.719-1.719a1.133,1.133,0,0,0-1.6,1.6Zm0,0",
    transform: "translate(-184.794 -212.307)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46801",
    "data-name": "Pfad 46801",
    d: "M223.216,354.719l1.756,1.756a1.133,1.133,0,0,0,1.6-1.6l-1.756-1.756,1.756-1.756a1.133,1.133,0,1,0-1.6-1.6l-1.756,1.756-1.756-1.756a1.133,1.133,0,1,0-1.6,1.6l1.756,1.756-1.756,1.756a1.133,1.133,0,0,0,1.6,1.6Zm0,0",
    transform: "translate(-194.659 -309.844)",
    fill: "rgba(46,207,150,0.25)",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLight1);
export default __webpack_public_path__ + "static/media/ProLight1.96e4dd9b016d9209d154155df2696e84.svg";
export { ForwardRef as ReactComponent };